
var jQuery = $;
if(jQuery('body iframe#byo').length > 0){

  
        window.addEventListener('message', messageHandler, true); // use this if you are going to enable the cart button

        function messageHandler(event){

            if(event.data.event == "byoLoaded") {
                handleLoad(event)
            }
            if(event.data.event == "cartUpdate") {
                addToCart(event)
            }
            if(event.data.event == "designUpdate") {
                handleCart(event)

              
            }
        }
        
        function handleLoad(event) {
            // enable the button in BYO
            document.querySelector('iframe#byo').contentWindow.postMessage({event:"enableCart",data:{}},"*")
        }
        
          
        function addToCart(event) {
            let designid = event.data.data.designid
            let designname = event.data.data.name
            let cart = event.data.data.items
          
            var items = [];
        
          jQuery.each(cart, function(index, item) {
            if(allVars[cart[index].article] != undefined){
                 items.push({id:allVars[cart[index].article],quantity:cart[index].quantity});
            }
          });

          console.log (items);
                 $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                   data: {items},
                    success: function(){ 
              			
                    }
                 });
          setTimeout(function(){
            window.location.href = 'https://www.battenhome.co/cart';
          }, 1000);
          
			
            // add your code for handling user did an add to cart click
        }
        
        function handleCart(event) {
            let designid = event.data.data.designid
            let designname = event.data.data.name
            let cart = event.data.data.items
            // add your code for handling article list changed in BYO
        }
}
